import React, { useEffect, useRef } from "react";
import { ErrorType, ErrorsSummedUpProps } from "./interfaces";

import { StyledAlert } from "App/global-style";
import { useErrorTexts } from "Store/texts/hooks";
import { useFormikContext } from "formik";
import { AccessibleCallUsMessage } from "../AccessibleCallUsMessage";
import { AlertType } from "../Alert";
import { ErrorList } from "./ErrorList";
import { ErrorWrapper } from "./styled";

export const ErrorsSummedUp = ({
  errors,
  isVisible = false,
}: ErrorsSummedUpProps): React.ReactElement | null => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { submitCount } = useFormikContext();

  useEffect(() => {
    if (wrapperRef.current !== null) {
      wrapperRef.current.focus();
    }
  }, [submitCount]);

  const breakingErrors = errors.filter(
    (error) => error.type === ErrorType.BREAKING,
  );
  const [
    {
      errorsSummedUp: { breakingError, validationError },
    },
    lang,
  ] = useErrorTexts();

  if (submitCount === 0 || errors.length === 0) {
    return null;
  }

  return (
    <ErrorWrapper
      id="errors-summed-up"
      tabIndex={-1}
      ref={wrapperRef}
      isVisible={isVisible}
    >
      {breakingErrors.length > 0 ? (
        <StyledAlert
          type="error"
          alertId="errors-summed-up"
          alertType={AlertType.STOPPER_ALERT}
          title={breakingError.title[lang]}
          description={breakingError.description[lang]}
          noReporting
        >
          <ErrorList errorArray={errors} type={ErrorType.BREAKING} />
          <AccessibleCallUsMessage />
        </StyledAlert>
      ) : (
        <StyledAlert
          type="error"
          alertId="errors-summed-up"
          alertType={AlertType.INPUT_ERROR_ALERT}
          title={validationError.title[lang]}
          noReporting
        >
          <ErrorList errorArray={errors} type={ErrorType.VALIDATION} />
        </StyledAlert>
      )}
    </ErrorWrapper>
  );
};
